import { render, staticRenderFns } from "./GoodsInfoTitle.vue?vue&type=template&id=81748232&scoped=true"
import script from "./GoodsInfoTitle.vue?vue&type=script&lang=js"
export * from "./GoodsInfoTitle.vue?vue&type=script&lang=js"
import style0 from "./GoodsInfoTitle.vue?vue&type=style&index=0&id=81748232&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81748232",
  null
  
)

export default component.exports